import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import { focusVisible } from '../../shared/global.styles.js';
import { EButtonVariant, ECgButtonSize } from './CgButton.js';
var disabledBase = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n"], ["\n  color: ", ";\n  background-color: ", ";\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.light;
});
var CgPrimary = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    ", "\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    ", "\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandBlue;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandBlueHover;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandBlueActive;
}, disabledBase);
var CgGhost = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.darkest;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.lightest;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.lighter;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.disabledGray;
});
var CgSecondary = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  border: 1px solid ", ";\n \n"], ["\n  ", "\n  border: 1px solid ", ";\n \n"])), CgGhost, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.disabledGray;
});
var CgTertiary = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    ", "\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    ", "\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandYellow;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.darkest;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandYellowHover;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandYellowActive;
}, disabledBase);
var CgPrio = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    ", "\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:disabled {\n    ", "\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandPurple;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandPrioHover;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandPrioActive;
}, disabledBase);

var buttonFontSize = function buttonFontSize(size, fontSize) {
  var _a, _b;

  switch (size) {
    case ECgButtonSize.small:
      return "".concat((_a = fontSize === null || fontSize === void 0 ? void 0 : fontSize.size) === null || _a === void 0 ? void 0 : _a.s2, "px");

    default:
      return "".concat((_b = fontSize === null || fontSize === void 0 ? void 0 : fontSize.size) === null || _b === void 0 ? void 0 : _b.s3, "px");
  }
};

var buttonPadding = function buttonPadding(size, spacings) {
  switch (size) {
    case ECgButtonSize.small:
      return "".concat(spacings === null || spacings === void 0 ? void 0 : spacings.xxs2, "px ").concat(spacings === null || spacings === void 0 ? void 0 : spacings.xs, "px");

    case ECgButtonSize.medium:
      return "".concat(spacings === null || spacings === void 0 ? void 0 : spacings.xs, "px ").concat(spacings === null || spacings === void 0 ? void 0 : spacings.xs2, "px");

    default:
      return "".concat(spacings === null || spacings === void 0 ? void 0 : spacings.xs2, "px ").concat(spacings === null || spacings === void 0 ? void 0 : spacings.sm, "px");
  }
};

var buttonShadow = function buttonShadow(size, variant) {
  if (variant === EButtonVariant.secondary || variant === EButtonVariant.ghost) return 'none';

  switch (size) {
    case ECgButtonSize.small:
      return 'inset 0px -1px 0px rgba(0, 0, 0, 0.15)';

    default:
      return 'inset 0px -2px 0px rgba(0, 0, 0, 0.15)';
  }
};

var CgButtonContainer = styled.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  border-radius: ", "px;\n  padding: ", ";\n  cursor: pointer;\n  outline: none;\n  border: none;\n  position: relative;\n  ", "\n    font-family: ", ";\n\n  ", "\n  &:disabled {\n    cursor: default;\n  }\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    box-shadow: ", ";\n    border-radius: ", "px;\n    top: 0;\n    left: 0;\n  }\n\n  ", "\n  ", "\n"], ["\n  border-radius: ", "px;\n  padding: ", ";\n  cursor: pointer;\n  outline: none;\n  border: none;\n  position: relative;\n  ", "\n    font-family: ", ";\n\n  ", "\n  &:disabled {\n    cursor: default;\n  }\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    box-shadow: ", ";\n    border-radius: ", "px;\n    top: 0;\n    left: 0;\n  }\n\n  ", "\n  ", "\n"])), function (props) {
  var _a;

  return props.round ? '100' : (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
}, function (props) {
  var _a;

  return props.isIconOnly ? "".concat((_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs, "px") : buttonPadding(props.size, props.theme.spacings);
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.fullWidth) && "width: 100%;";
}, function (props) {
  var _a, _b;

  return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.typography) === null || _b === void 0 ? void 0 : _b.type.primary;
}, focusVisible, function (props) {
  return buttonShadow(props.size, props.variant);
}, function (props) {
  var _a;

  return props.round ? '100' : (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
}, function (props) {
  switch (props.variant) {
    case EButtonVariant.primary:
      return CgPrimary;

    case EButtonVariant.secondary:
      return CgSecondary;

    case EButtonVariant.tertiary:
      return CgTertiary;

    case EButtonVariant.prio:
      return CgPrio;

    case EButtonVariant.ghost:
      return CgGhost;

    default:
      return CgPrimary;
  }
}, function (props) {
  var _a;

  return props.loading && "\n    background-color: ".concat((_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.lightest, "\n    ");
});
var CgButtonContent = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\ndisplay: flex;\njustify-content: center;\nalign-items: center;\ngap: ", "px;\nflex-direction: ", ";\nfont-size  ", ";\n", ";\nwhite-space: nowrap;\nmin-width: max-content;\n"], ["\ndisplay: flex;\njustify-content: center;\nalign-items: center;\ngap: ", "px;\nflex-direction: ", ";\nfont-size  ", ";\n", ";\nwhite-space: nowrap;\nmin-width: max-content;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs;
}, function (props) {
  return props.flexReverse ? 'row-reverse' : 'row';
}, function (props) {
  return buttonFontSize(props.size, props.theme.typography);
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.loading) && "opacity: 0";
});
var CgButtonLoader = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: grid;\n  place-content: center;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: grid;\n  place-content: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
export { CgButtonContainer, CgButtonContent, CgButtonLoader };